import { FilterOffIcon } from '~/@mid_ui/icons/FilterOffIcon'
import { FilterOnIcon } from '~/@mid_ui/icons/FilterOnIcon'
import { cn } from '~/shadcn/lib/utils'
import { Button } from '~/shadcn/ui/button/button'

type Props = {
  toggleFilterOpen: () => void
  isFilterOpen: boolean
  activeFiltersCount: string
}

function FilterToggleButton({
  toggleFilterOpen,
  isFilterOpen,
  activeFiltersCount,
}: Props) {
  return (
    <Button
      onClick={toggleFilterOpen}
      variant="ghost"
      size="small"
      className="px-2 gap-2 bg-transparent">
      {isFilterOpen ? (
        <>
          <FilterOffIcon className="text-accent" />
          <div className={cn('scroll-m-20 text-base text-accent')}>
            {`Zavrieť filtre${activeFiltersCount}`}
          </div>
        </>
      ) : (
        <>
          <FilterOnIcon />
          <div className={cn('scroll-m-20 text-base')}>
            {`Filtrovať${activeFiltersCount}`}
          </div>
        </>
      )}
    </Button>
  )
}

export { FilterToggleButton }
